import { openCrispChat } from "../../../lib/utility";
import { manageStorageService } from "../../../services/manageStorageService";
import { userDetailStore } from "../../../stores/userDetailStore";


export function ManageStorage() {
    let userDetailStoreUnsubscribe: () => void;
    let $storageUsedElement: null | HTMLDivElement = null;
    let $totalStorageElement: null | HTMLDivElement = null;
    let $storageSlider: null | HTMLDivElement = null;
    let $messageBtn: null | HTMLButtonElement = null;
    let $storageLimitReachedMessage: null | HTMLElement = null;
    // let $storageLimitReachedBox: null | HTMLElement = null;
    let $storageUsedBox: null | HTMLElement = null;
    let $reachedStorageUsed: null | HTMLElement = null;

    let isFetched = false;
    function init() {
        $storageUsedElement = document.getElementById("storage-used") as HTMLDivElement;
        $totalStorageElement = document.getElementById("total-storage") as HTMLDivElement;
        $storageSlider = document.getElementById("storage-slider") as HTMLDivElement;
        $messageBtn = document.getElementById("message-btn") as HTMLButtonElement;
        $storageLimitReachedMessage = document.getElementById("storage-limit-reached-message") as HTMLElement | null;
        // $storageLimitReachedBox = document.getElementById("storage-limit-reached-box") as HTMLElement | null;
        $storageUsedBox = document.getElementById("storage-used-box") as HTMLElement | null;
        $reachedStorageUsed = document.getElementById("reached-storage-used") as HTMLElement | null;
        
        if ($messageBtn) {
            $messageBtn.addEventListener("click", () => {
                openCrispChat();
            })
        }
        userDetailStoreUnsubscribe = userDetailStore.subscribe(({ userDetail,isLoading }) => !isLoading && callStorageDataAPI(userDetail.id)); // populate the loading state if workspaces loading
    }

    function callStorageDataAPI(userId: number) {
        const activeTabElement = document.querySelector('[data-hs-tab].active')
        if (activeTabElement && activeTabElement!.id === "myaccount-storage"  && !isFetched) {
            isFetched = true;
            populate(userId);
        }
    }

    async function populate(userDetailId: number) {
        if (userDetailId) {
            const storageData: any = await manageStorageService.getStorageData(userDetailId);
            // 1.10 GB / 10 GB Used
            const storageUsedString: string = `${storageData.storage_used} ${storageData.storage_unit} / ${storageData.storage_allowed} ${storageData.storage_unit} Used`;
            $storageUsedElement!.innerText = storageUsedString;
            $reachedStorageUsed!.innerText = storageUsedString;

            // 10 GB
            const usedStorageInPercentage: string = `${storageData.storage_percentage} %`;
            $totalStorageElement!.innerText = usedStorageInPercentage;

            // storage slider
            const sliderPercentage: boolean = storageData.storage_percentage;
            $storageSlider!.style.width = `${sliderPercentage}%`;
            
            // storageData.hasOwnProperty('show_storage_alert') && storageData.show_storage_alert ||
            if (storageData.hasOwnProperty('is_storage_limit_reached') && storageData.is_storage_limit_reached) {
                $storageLimitReachedMessage!.classList.remove("hidden");
                $storageSlider!.classList.remove("bg-blue-600");
                $storageSlider!.classList.add("bg-red-500");
                $storageUsedBox!.classList.remove("hidden");
            } 
            // else if (storageData.hasOwnProperty('is_storage_limit_exceeded') && storageData.is_storage_limit_exceeded) {
            //     $storageLimitReachedBox!.classList.remove("hidden");
            //     $storageUsedBox!.classList.add("hidden");
            // } 
            else {
                $storageLimitReachedMessage!.classList.add("hidden");
                $storageSlider!.classList.add("bg-blue-600");
                $storageSlider!.classList.remove("bg-red-500");
                $storageUsedBox!.classList.remove("hidden");
            }
        }
    }

    function cleanUp() {
        if (userDetailStoreUnsubscribe) {
            userDetailStoreUnsubscribe();
        }
    }
    function render() {
        return /*html*/`
        <div id="vertical-tab-myaccount-storage" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-myaccount-storage">
            <div class="p-4 md:p-5 bg-white border border-gray-200 shadow-sm rounded-xl dark:bg-neutral-800 dark:border-neutral-700">
                <!-- Title -->
            <div class="flex justify-between gap-x-3 mb-4 xl:mb-8">
                <div>
                <h3 class="text-lg font-semibold text-gray-800 dark:text-neutral-200">
                    Manage Storage
                </h3>
                <p class="text-sm text-gray-500 dark:text-neutral-500">
                    Chat with us by clicking below to upgrade your storage space.
                </p>
                </div>
            </div>
            <!-- End Title -->
            <div class="space-y-8">
                <!-- Start Storage Card -->
                <div class="overflow-hidden flex flex-col bg-white border border-gray-200 rounded-xl dark:bg-neutral-800 dark:border-neutral-700">
                <!-- Body -->
                <div class="h-full p-6">
                    <svg class="w-[34px] h-[30px] dark:text-white" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-database"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M3 5V19A9 3 0 0 0 21 19V5"/><path d="M3 12A9 3 0 0 0 21 12"/></svg>
                    
    
                    <div class="mt-3">
                    <div>
                        <h2 class="text-xl font-semibold text-gray-800 dark:text-neutral-200">
                        Storage Used
                        </h2>  
                    </div>
                    </div>
    
                    <!--Start storage Progress -->
                    <div class="hidden p-3 pd:p-4 mt-4 relative after:absolute after:left-0 after:top-0 after:w-full after:h-full after:block after:content-[''] after:bg-[url('/images/red-alert-light-bg.svg')] after:bg-cover after:bg-left-top after:bg-no-repeat bg-gradient-to-l from-red-50 to-white rounded-xl shadow-[0px_2px_4px_-2px_rgba(0,0,0,0.10)] border border-red-200 dark:border-red-800 dark:from-red-950 dark:to-black dark:after:bg-[url('/images/red-alert-dark-bg.svg')] dark:after:opacity-70" id="storage-limit-reached-box">
                        <div class="flex flex-col pd:flex-col pd:items-start lp:flex-row lp:items-center xlp:flex-row xlp:items-center items-start gap-4 lg:justify-between relative z-[2]">
                            <div class="flex items-center gap-3 pd:gap-5 w-full">
                            <div class="shrink-0 inline-flex items-center justify-center w-[61px] h-[61px] lg:w-[76px] lg:h-[76px] bg-white rounded-full shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10)] border border-slate-200 dark:border-neutral-700 dark:bg-neutral-950 mb-auto">
                                <div class="w-[53px] h-[53px] lg:w-[68px] lg:h-[68px] overflow-hidden rounded-full inline-flex justify-center items-center bg-red-100 border border-[#ffe2e2]">
                                <svg class="size-[24px] lg:size-[34px]" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                                    <path d="M17 11.4933C23.8435 11.4933 29.3913 9.64403 29.3913 7.36286C29.3913 5.08168 23.8435 3.23242 17 3.23242C10.1565 3.23242 4.6087 5.08168 4.6087 7.36286C4.6087 9.64403 10.1565 11.4933 17 11.4933Z" stroke="#EF4444" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M4.6087 7.36328V26.6386C4.60103 27.3008 5.07103 27.9538 5.97908 28.5427C6.88713 29.1316 8.20662 29.6391 9.82631 30.0225C11.446 30.4058 13.3184 30.6537 15.2858 30.7453C17.2531 30.8369 19.2576 30.7695 21.1304 30.5488" stroke="#EF4444" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M29.3913 7.36328V11.4937" stroke="#EF4444" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M29.3913 17L25.2609 23.8841H30.7681L26.6377 30.7681" stroke="#EF4444" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M4.6087 17C4.61069 17.6437 5.06399 18.2783 5.93244 18.8533C6.80089 19.4282 8.06044 19.9275 9.6106 20.3114C11.1608 20.6952 12.9586 20.953 14.8607 21.0642C16.7628 21.1753 18.7165 21.1367 20.5659 20.9514" stroke="#EF4444" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                            </div>
                            <div class="flex gap-1 flex-col">
                                <p class="text-red-800 text-xs font-semibold leading-none dark:text-red-700" id="reached-storage-used"></p>
                                <h3 class="text-gray-800 text-xs sm:text-sm md:text-base font-semibold leading-tight dark:text-white">Your storage limit already exceeds, please upgrade or get more storage. Otherwise your collected reviews will be locked.</h3>
                            </div>
                            </div>
                        </div>
                        </div>
                    <div class="my-4" id="storage-used-box">
                    <div class="flex justify-between items-center gap-x-2 mb-1">
                        <h4 class="font-medium text-gray-800 dark:text-neutral-200" id="total-storage">
                        </h4>
                        <p class="text-sm text-gray-500 dark:text-neutral-500" id="storage-used">
                        </p>
                    </div>
                    <div class="flex w-full h-2.5 bg-gray-200 rounded-full overflow-hidden dark:bg-neutral-700" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div class="flex flex-col justify-center overflow-hidden bg-blue-600 text-xs text-white text-center rounded-full whitespace-nowrap" style="width: 0" id="storage-slider"></div>
                    </div>
                    <div class="mt-5 hidden" id="storage-limit-reached-message">
                        <div class="bg-gray-50 border border-gray-200 rounded-lg py-3 px-4 dark:bg-neutral-900 dark:border-neutral-700">
                            <div class="flex">
                                <div class="shrink-0 pt-1">
                                    <svg class="shrink-0 text-[#1F2937] dark:text-neutral-700" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_6781_2267)">
                                        <path d="M8.00004 14.6673C11.6819 14.6673 14.6667 11.6825 14.6667 8.00065C14.6667 4.31875 11.6819 1.33398 8.00004 1.33398C4.31814 1.33398 1.33337 4.31875 1.33337 8.00065C1.33337 11.6825 4.31814 14.6673 8.00004 14.6673Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M6.06006 6.00038C6.21679 5.55482 6.52616 5.17912 6.93336 4.9398C7.34056 4.70049 7.81932 4.61301 8.28484 4.69285C8.75036 4.7727 9.1726 5.01473 9.47678 5.37606C9.78095 5.7374 9.94743 6.19473 9.94673 6.66705C9.94673 8.00038 7.94673 8.66705 7.94673 8.66705" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M8 11.334H8.00667" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_6781_2267">
                                        <rect width="16" height="16" fill="white"/>
                                        </clipPath>
                                        </defs>
                                        </svg>
                                </div>
                                <div class="ms-3">
                                    <h3 class="text-gray-800 text-sm font-semibold dark:text-white">
                                        You maxed out storage limit
                                    </h3>
                                    <p class="mt-1 text-sm font-normal text-gray-600 dark:text-neutral-400">
                                        Please upgrade your plan to add more storage limit & chat with us to get a custom storage quote.
                                    </p>
                                </div>
                            </div>
                            </div>
                    </div>
                    </div>
                    <button type="button" id="message-btn" class="mt-3 w-full py-2 px-3 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none">
                    Get More Space <svg class="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-down-right"><path d="m7 7 10 10"/><path d="M17 7v10H7"/></svg>
                    </button>
                    <!-- End storage Progress -->
                </div>
                <!-- End Body -->
                </div>
                <!-- End Storage Card -->
            </div>
            </div>
            <!-- End Title -->
        </div>
        `
    }

    return {
        render,
        init,
        cleanUp,
        populate
    }
}
